export default (filter) => {
  if (filter.selectedMaxValue) {
    return {
      associatedFieldName: filter.associatedFieldName,
      selectedMinValue: filter.selectedMinValue,
      selectedMaxValue: filter.selectedMaxValue,
    };
  }
  return {
    associatedFieldName: filter.associatedFieldName,
    name: filter.name,
  };
};
